import { useQuery } from "@tanstack/react-query";
import { route } from "../../../../../../shim/jsbridge";
import { Analysis } from "../../../../@types";
import api from "../../../../api";
import { sampleReportKeys } from "../../../../queryKeys";

const useGetDomainCounts = <T>(
  hash: string | undefined,
  analysis: Analysis,
  uploadId?: string
) => {
  const endpoint = hash
    ? route(`api_${analysis}_domain_counts`, [hash])
    : route(`api_${analysis}_url_domain_counts`, [uploadId]);

  return useQuery({
    queryKey: sampleReportKeys.domainCounts(hash, analysis, endpoint),
    queryFn: () => api.getDynamicAnalysisData<T>(endpoint),
    select: ({ data: counts }) => counts
  });
};

export default useGetDomainCounts;
